import axios from 'axios';
import { setAlert } from './alert';
import setAuthToken from '../utils/setAuthToken'

import {
    GET_PROFILE,
    GET_PROFILES,
    GET_PROFILE_REQUEST,
    GET_PACKAGES_MEMBERSHIPS,
    CREATE_PROFILE,
    DELETE_PROFILE,
    CLEAR_PROFILE,
    CLEAR_NEW_PROFILE_CREATED
} from './types';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Get Profiles
export const getProfiles = () => async dispatch => {
    if( localStorage.token ){
        setAuthToken( localStorage.token )
    }
    dispatch({
        type : GET_PROFILE_REQUEST,
        payload: true
    });
    
    
    try {
        const res =  await axios.get(`${API_URL}/product-profiles/profiles`);        
        if(res.data.success){            
            dispatch({
                type : GET_PROFILES,
                payload: res.data.productProfiles
            });
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch(setAlert('Failed to fetch Products', 'danger'));
    }
}

// Get a Profile
export const getProfile = id => async dispatch => {
    if( localStorage.token ){
        setAuthToken( localStorage.token )
    }
    dispatch({
        type : GET_PROFILE_REQUEST,
        payload: true
    });
    try {
        const res =  await axios.get(`${API_URL}/product-profiles/${id}`);
  
        if(res.data.success){  
            dispatch({
                type : GET_PROFILE,
                payload: res.data
            });
            dispatch( setAlert('Successfully fetched Product details', 'success') );
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to get Product details', 'danger'));
    }
};

// Clear Profile (for new profile creation)
export const clearProfile = () => dispatch => {
    dispatch({
        type: CLEAR_PROFILE
    });
};

// Clear new profile created
export const clearNewProfileCreated = () => dispatch => {
    dispatch({
        type: CLEAR_NEW_PROFILE_CREATED
    });
};




// Create profile
export const createProfile = (formData) => async dispatch => {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    try {
        const res =  await axios.post(`${API_URL}/product-profiles`, formData, config);
        if(res.data.success){
            dispatch(setAlert('Profile Created', 'success'));
            dispatch({
                type : CREATE_PROFILE,
                payload: res.data
            });
        }else{
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch( setAlert('Error: Failed to update product', 'danger') );
    }
};

// Update profile
export const updateProfile = (id, formData) => async dispatch => {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };  
    try {
        const res =  await axios.put(`${API_URL}/product-profiles/${id}`, formData, config);
        if(res.data.success){ 
            dispatch(setAlert('Profile Updated', 'success'));
            dispatch(getProfile(id));
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }      
    } catch (err) {
        dispatch( setAlert('Error: Failed to update product', 'danger') );
    }
};







// Get Packages and Memberships for Product Profile creation
export const getPackagesMemberships = () => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    dispatch({
        type: GET_PROFILE_REQUEST,
        payload: true
    });
    try {
        const res = await axios.get(`${API_URL}/product-profiles/packages-memberships`);
        if (res.data.success) {
            dispatch({
                type: GET_PACKAGES_MEMBERSHIPS,
                payload: res.data
            });
            dispatch(setAlert('Successfully fetched packages and memberships', 'success'));
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch(setAlert('Failed to fetch packages and memberships', 'danger'));
    }
};

// Upload banner asset to profile
export const uploadProfileBannerAsset = (assetData) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    };
    try {
        const res = await axios.post(`${API_URL}/product-profiles/banner-assets`, assetData, config);
        if (res.data.success) {
            dispatch(setAlert('Banner asset uploaded successfully', 'success'));
            return res.data;
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
            return null;
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to upload banner asset', 'danger'));
        return null;
    }
};

// Delete banner asset from profile
export const deleteProfileBannerAsset = (profileId, bannerId, imageName) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    try {
        const res = await axios.delete(`${API_URL}/product-profiles/${profileId}/banner/${bannerId}/image/${imageName}`);
        if (res.data.success) {
            dispatch(setAlert('Banner asset deleted successfully', 'success'));
            return res.data;
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
            return null;
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to delete banner asset', 'danger'));
        return null;
    }
};

// Delete profile
export const deleteProfile = (profileId) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    try {
        const res = await axios.delete(`${API_URL}/product-profiles/${profileId}`);
        if (res.data.success) {
            dispatch({
                type: DELETE_PROFILE,
                payload: res.data.productProfiles
            });
            dispatch(setAlert('Profile deleted successfully', 'success'));
            // Refresh the profiles list
            dispatch(getProfiles());
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to delete profile', 'danger'));
    }
};
